import { render } from "./FeedbackComponent.vue?vue&type=template&id=ccde49e2&scoped=true"
import script from "./FeedbackComponent.vue?vue&type=script&lang=js"
export * from "./FeedbackComponent.vue?vue&type=script&lang=js"

import "./FeedbackComponent.vue?vue&type=style&index=0&id=ccde49e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccde49e2"]])

export default __exports__